import React from 'react';

// P7.489 — Badge du mode du moteur (LIVE / PAPER), partagé par toutes les pages.
// Source : GET /api/risk/state → `mode` = bot:mode publié par sniper-v3 depuis son
// env MODE (INV-011) > MODE env du container dashboard > "unknown".
// Jamais "PAPER" par défaut : tant que le mode n'est pas confirmé (chargement,
// erreur réseau, valeur inconnue) le badge affiche « MODE ? ». Un PAPER affiché
// à tort pendant que le capital réel tourne est l'erreur la plus coûteuse.

export function runtimeModeView(riskData, { isError = false } = {}) {
  const raw = riskData && typeof riskData.mode === 'string' ? riskData.mode.trim().toLowerCase() : '';
  const mode = isError ? 'unknown' : (raw === 'live' || raw === 'paper' ? raw : 'unknown');
  const isLive = mode === 'live';
  const isPaper = mode === 'paper';
  const mismatch = Boolean(riskData && riskData.mode_mismatch);
  let label = 'MODE ?';
  if (isLive) label = 'LIVE — CAPITAL RÉEL';
  else if (isPaper) label = 'PAPER';
  const source = (riskData && riskData.mode_source) || 'none';
  const env = riskData && riskData.mode_env;
  const title = isError
    ? 'Mode non confirmé : /api/risk/state en erreur'
    : `Mode du moteur — source : ${source}${mismatch ? ` (MODE du container dashboard : ${env})` : ''}`;
  const short = isLive ? 'LIVE' : isPaper ? 'PAPER' : 'MODE ?';
  return { mode, isLive, isPaper, isUnknown: !isLive && !isPaper, mismatch, label, short, title, env };
}

const UNKNOWN_STYLE = {
  background: 'rgba(255,184,0,.13)',
  color: '#ffb800',
  border: '1px solid rgba(255,184,0,.45)',
};

// Variante en ligne (dans une phrase, ex. ArmingConsole) : styles autonomes, sans CSS de page.
const INLINE_STYLES = {
  live: { background: '#ff3b5c', color: '#fff' },
  paper: { background: 'rgba(0,224,138,.13)', color: '#00e08a', border: '1px solid rgba(0,224,138,.4)' },
  unknown: UNKNOWN_STYLE,
};

export default function ModeBadge({ view, className = 'mode', inline = false }) {
  const cls = view.isLive ? 'live' : view.isPaper ? 'paper' : 'unknown';
  if (inline) {
    return (
      <span
        className={`mode-inline ${cls}`}
        style={{ ...INLINE_STYLES[cls], padding: '1px 7px', borderRadius: 5, fontWeight: 800 }}
        title={view.title}
        data-mode={view.mode}
      >
        {view.short}
        {view.mismatch && ` ≠ env ${String(view.env || '?').toUpperCase()}`}
      </span>
    );
  }
  return (
    <div
      className={`${className} ${cls}`}
      style={view.isUnknown ? UNKNOWN_STYLE : undefined}
      title={view.title}
      data-mode={view.mode}
    >
      <span className={className === 'mode' ? 'dot' : 'mdot'} /> {view.label}
      {view.mismatch && (
        <span style={{ fontSize: 10, fontWeight: 600, opacity: 0.85 }}>
          {' '}≠ env {String(view.env || '?').toUpperCase()}
        </span>
      )}
    </div>
  );
}
